import { Query } from '@/modules/plugins/query'
import { Client } from '@/api'
import store from '@/modules/store'
import qs from 'qs'
import Vue from 'vue'

class Search {
    constructor() {
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'restaurant/quick-search'
        this._client = new Client()
    }

    get base() {
        return `${this.apiRoot}/${this.apiVersion}/${this.apiBase}`
    }

    fetch(search) {
        return new Promise((resolve, reject) => {
            try {
                let time = store.getters['order/time']
                let asap = store.getters['order/asap']
                let address = store.getters['order/address']
                const params = qs.stringify(
                    {
                        ...Query.getLocationParams(address),
                        ...Query.getDeliveryTimeParams(
                            time ? (asap ? undefined : time) : undefined
                        ),
                        ...{ search: search },
                    },
                    {
                        encode: true,
                        arrayFormat: Vue.prototype.$arrayFormat,
                    }
                )
                const url = this.base + (params !== '' ? `?${params}` : '')
                window.debug.info(`Search: ${url}`)
                this._client.index(url).then((res) => {
                    return resolve(res)
                })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

export { Search }
